/**
 * @module weekdays
 * @description A list of weekdays
 */

export const weekdays = [
	'sunday',
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
] as const;
export type Weekdays = (typeof weekdays)[number];
